import React from 'react';
import { motion } from 'framer-motion';
export function BeyondCocktails() {
  return <section className="relative w-full py-20 px-6" data-id="element-22">
      {/* Background with Teal Overlay */}
      <div className="absolute inset-0 z-0 overflow-hidden" data-id="element-23">
        <img src="https://cdn.magicpatterns.com/uploads/2v425qbnRr5JBot5Vvba2V/pexels-picha-6210508.jpg" alt="Beyond the Cocktails background" className="w-full h-full object-cover" data-id="element-24" />
        <div className="absolute inset-0 bg-[#992f74]/80 mix-blend-multiply" data-id="element-25" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center space-y-8" data-id="element-26">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-5xl font-black italic tracking-wider text-white uppercase drop-shadow-md font-montserrat" data-id="element-27">
          Sip. Savour. Celebrate.
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-white text-lg md:text-xl font-medium leading-relaxed max-w-3xl mx-auto flex flex-col items-center gap-8 font-montserrat" data-id="element-28">
          <p data-id="element-29">
            From expertly crafted cocktails and signature mocktails to exquisite
            gourmet bites, every element is designed to deliver an elevated
            experience. With impeccable presentation, refined attention to
            detail, and first-class hospitality, we transform moments into
            unforgettable celebrations—bringing your vision to life with
            elegance, excellence, and seamless execution.
          </p>

          <motion.a href="/works" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-white text-[#992f74] px-10 py-4 text-sm font-bold tracking-widest uppercase hover:bg-[#992f74] hover:text-white transition-colors duration-300 shadow-xl" data-id="element-30">
            See Our Works
          </motion.a>
        </motion.div>
      </div>

      {/* Floating Logo Badge */}
      <div className="absolute bottom-0 right-12 md:right-24 translate-y-1/2 z-20" data-id="element-31">
        <div className="w-32 h-32 md:w-40 md:h-40 rounded-full bg-white p-1 border-4 border-[#992f74] shadow-2xl overflow-hidden" data-id="element-32">
          <img src="https://cdn.magicpatterns.com/uploads/58tNa4GTAAmpR1FoCHN2wS/Image_(57).jpg" alt="Sips & Nibblez Logo" className="w-full h-full object-cover rounded-full" data-id="element-33" />
        </div>
      </div>
    </section>;
}